import dayjs from 'dayjs';
// import utc from 'dayjs/plugin/utc';

// dayjs.extend(utc);

const convertFiltersStatistic = ({ from, to, is_user_ranking, isComparisonMode, metric_name }) => {
  const params = new URLSearchParams();

  params.append('date_from', dayjs(/* .utc */ from).format('YYYY-MM-DD'));
  params.append('date_to', dayjs(/* .utc */ to).format('YYYY-MM-DD'));
  params.append('compare_with_previous', isComparisonMode);
  if (isComparisonMode && metric_name) {
    params.append('metric_name', metric_name);
  }
  if (is_user_ranking) {
    params.append('is_user_ranking', is_user_ranking);
  }

  return params;
};

const convertFiltersBalanceStatistic = ({ role, from, to, isAsc }) => {
  const params = new URLSearchParams();

  params.append('date_from', dayjs(/* .utc */ from).format('YYYY-MM-DD'));
  params.append('date_to', dayjs(/* .utc */ to).format('YYYY-MM-DD'));
  params.append('target_role', role);
  params.append('asc', isAsc);
  params.append('limit', '10');
  params.append('offset', '0');

  return params;
};

export { convertFiltersStatistic, convertFiltersBalanceStatistic };
